/**
 * Single source of truth for the app's locale policy.
 *
 * The engine's default collation locale comes from the OS process locale (on
 * Linux, LANG / LC_COLLATE) - not from the browser's language preference.
 * Relying on it means a bare localeCompare() can collate Swedish å/ä/ö as a/o
 * even when the user has chosen Swedish in the browser, so we always pass a tag
 * explicitly instead. Change APP_LOCALE here and everything below follows.
 *
 * This module is deliberately a leaf: it must not import anything, and ./string
 * and ./date must import it directly rather than the ./index barrel, or the
 * cycle would leave APP_LOCALE in the temporal dead zone on first read.
 */

/**
 * Tag for all locale-aware data formatting and sorting: the browser's own
 * language, falling back to Swedish.
 */
export const APP_LOCALE: string =
  typeof navigator !== "undefined" && navigator.language ? navigator.language : "sv-SE";
